import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full" }
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_5 = { class: "flex justify-between items-start" }
const _hoisted_6 = { class: "mt-8" }
const _hoisted_7 = { class: "flex justify-between items-center mb-4" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-center items-center py-8"
}
const _hoisted_10 = {
  key: 1,
  class: "bg-red-50 border-l-4 border-red-500 p-4 mb-4"
}
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "ml-3" }
const _hoisted_13 = { class: "text-sm text-red-700" }
const _hoisted_14 = ["readonly"]
const _hoisted_15 = ["readonly"]
const _hoisted_16 = {
  key: 0,
  class: "border border-gray-300 rounded-t-md bg-gray-50 p-2 flex flex-wrap gap-1"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "bg-gray-50 px-4 py-3 sm:px-6 flex justify-between" }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[13] || (_cache[13] = _createStaticVNode("<div data-v-ab97f916><h3 class=\"text-xl font-bold text-gray-900\" data-v-ab97f916> Revenue Forecast Template </h3><p class=\"text-sm text-gray-500 mt-1\" data-v-ab97f916>Template for forecasting and planning purposes</p></div><div class=\"flex items-center space-x-2 mx-4\" data-v-ab97f916><div class=\"flex flex-col items-center\" data-v-ab97f916><div class=\"h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs\" data-v-ab97f916>1</div><span class=\"text-xs mt-1\" data-v-ab97f916>Creating</span></div><div class=\"w-4 h-0.5 bg-blue-600\" data-v-ab97f916></div><div class=\"flex flex-col items-center\" data-v-ab97f916><div class=\"h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs\" data-v-ab97f916>2</div><span class=\"text-xs mt-1\" data-v-ab97f916>Pending Review</span></div><div class=\"w-4 h-0.5 bg-gray-200\" data-v-ab97f916></div><div class=\"flex flex-col items-center\" data-v-ab97f916><div class=\"h-6 w-6 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center text-xs\" data-v-ab97f916>4</div><span class=\"text-xs mt-1\" data-v-ab97f916>Email Sent</span></div></div>", 2)),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  class: "text-gray-400 hover:text-gray-500"
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("svg", {
                    class: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"mt-6 grid grid-cols-1 md:grid-cols-2 gap-6\" data-v-ab97f916><div data-v-ab97f916><h4 class=\"font-medium mb-3\" data-v-ab97f916>Template Information</h4><div class=\"space-y-2\" data-v-ab97f916><div class=\"flex justify-between\" data-v-ab97f916><span class=\"text-gray-500\" data-v-ab97f916>Modified:</span><span data-v-ab97f916>2025-04-02</span></div><div class=\"flex justify-between\" data-v-ab97f916><span class=\"text-gray-500\" data-v-ab97f916>Format:</span><span data-v-ab97f916>Excel (.xlsx)</span></div><div class=\"flex justify-between\" data-v-ab97f916><span class=\"text-gray-500\" data-v-ab97f916>Size:</span><span data-v-ab97f916>245 KB</span></div><div class=\"flex justify-between\" data-v-ab97f916><span class=\"text-gray-500\" data-v-ab97f916>Status:</span><span class=\"bg-blue-600 text-white text-xs px-2 py-1 rounded-full\" data-v-ab97f916>Email Pending</span></div></div></div><div data-v-ab97f916><h4 class=\"font-medium mb-3\" data-v-ab97f916>Planner</h4><div class=\"flex items-center\" data-v-ab97f916><div class=\"h-10 w-10 rounded-full bg-gray-200 flex-shrink-0\" data-v-ab97f916></div><div class=\"ml-3\" data-v-ab97f916><p class=\"font-medium\" data-v-ab97f916>Luka Novak</p><p class=\"text-sm text-gray-500\" data-v-ab97f916>Financial Planner</p></div></div></div></div>", 1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "font-medium" }, "Email Template Preview", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-2 text-xs px-2 py-0.5 rounded-full", _ctx.isEditMode ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'])
                    }, _toDisplayString(_ctx.isEditMode ? 'Editable' : 'Read-only'), 3)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args))),
                    class: _normalizeClass(["text-sm px-3 py-1 rounded-md border", _ctx.isEditMode
                  ? 'border-red-300 bg-red-50 text-red-700 hover:bg-red-100'
                  : 'border-blue-300 bg-blue-50 text-blue-700 hover:bg-blue-100'])
                  }, _toDisplayString(_ctx.isEditMode ? 'Disable Editing' : 'Enable Editing'), 3)
                ]),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[15] || (_cache[15] = [
                      _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" }, null, -1),
                      _createElementVNode("span", { class: "ml-2" }, "Loading template...", -1)
                    ])))
                  : (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                            _createElementVNode("svg", {
                              class: "h-5 w-5 text-red-500",
                              viewBox: "0 0 20 20",
                              fill: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                "clip-rule": "evenodd"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.errorMessage), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["space-y-4 bg-white border-2 rounded-md p-4 transition-colors duration-200", _ctx.isEditMode ? 'border-blue-300' : 'border-gray-200'])
                      }, [
                        _createElementVNode("div", null, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "To", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailData.to) = $event)),
                            class: _normalizeClass([
                    'w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none',
                    _ctx.isEditMode
                      ? 'border-blue-300 focus:ring-blue-500 focus:border-blue-500 bg-white'
                      : 'border-gray-200 bg-gray-50 cursor-default'
                  ]),
                            readonly: !_ctx.isEditMode
                          }, null, 10, _hoisted_14), [
                            [_vModelText, _ctx.emailData.to]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Subject", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailData.subject) = $event)),
                            class: _normalizeClass([
                    'w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none',
                    _ctx.isEditMode
                      ? 'border-blue-300 focus:ring-blue-500 focus:border-blue-500 bg-white'
                      : 'border-gray-200 bg-gray-50 cursor-default'
                  ]),
                            readonly: !_ctx.isEditMode
                          }, null, 10, _hoisted_15), [
                            [_vModelText, _ctx.emailData.subject]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Message", -1)),
                          (_ctx.isEditMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("button", {
                                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.applyFormatting('bold')), ["prevent"])),
                                  class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                                  title: "Bold"
                                }, _cache[19] || (_cache[19] = [
                                  _createElementVNode("span", { class: "font-bold text-lg" }, "B", -1)
                                ])),
                                _createElementVNode("button", {
                                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.applyFormatting('italic')), ["prevent"])),
                                  class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                                  title: "Italic"
                                }, _cache[20] || (_cache[20] = [
                                  _createElementVNode("span", { class: "italic text-lg" }, "i", -1)
                                ])),
                                _createElementVNode("button", {
                                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.applyFormatting('underline')), ["prevent"])),
                                  class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                                  title: "Underline"
                                }, _cache[21] || (_cache[21] = [
                                  _createElementVNode("span", { class: "underline text-lg" }, "U", -1)
                                ]))
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.isEditMode)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "prose max-w-none w-full px-3 py-2 border rounded-md shadow-sm overflow-auto border-gray-200 bg-gray-50 cursor-default h-64",
                                innerHTML: _ctx.sanitizedMessageHtml
                              }, null, 8, _hoisted_17))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                id: "email-content-editor",
                                contenteditable: "true",
                                onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updateEmailContent && _ctx.updateEmailContent(...args))),
                                class: "w-full min-h-[250px] px-3 py-2 border border-gray-300 rounded-b-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                              }, null, 32))
                        ])
                      ], 2))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.navigateToEditTemplate && _ctx.navigateToEditTemplate(...args))),
                  class: "inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                }, " Edit Template ")
              ]),
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args))),
                disabled: _ctx.isLoading,
                class: "inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              }, _toDisplayString(_ctx.isLoading ? 'Sending...' : 'Send Email'), 9, _hoisted_19)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}